import { useMemo } from "react";
import { useAppSelector } from "@store";
import { SortDirections } from "app/ApiClient";
import { sortString } from "utils/sortHelper";

export const useNormalizedModifications = (sorting: SortDirections) => {
  const { modifications } = useAppSelector((state) => state.projectSelector);

  const sortedModifications = useMemo(
    () => [...modifications].sort((a, b) => sortString(a.name, b.name, sorting)),
    [sorting, modifications],
  );
  return {
    sortedModifications,
  };
};
